import React from 'react';
import { AdminSelect } from '@project/components';
import themes from './../ViewProfile/themes';
import { useIntl } from 'react-intl';

export default function ThemeSelect({ spaceProfile, updateField, saveProfile, isReadOnly, propStyles }) {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  const themeOptions = Object.keys(themes)
    .map(themeKey => ({ label: themes[themeKey].name, value: themeKey, companies: themes[themeKey].companies }))
    .filter(theme => theme.companies && theme.companies.length ? theme.companies.includes(spaceProfile.company) : true);

  const themeValue = { label: spaceProfile.theme ? themes[spaceProfile.theme].name : t('ui.default'), value: spaceProfile.theme || 'default' };

  const onSelectTheme = ({ value }) => {
    updateField('theme', { target: { value } }, spaceProfile);
    saveProfile(true);
  }

  return <AdminSelect
    id="themeSelect"
    value={themeValue}
    label={t('ui.theme')}
    options={themeOptions}
    onChange={onSelectTheme}
    isDisabled={isReadOnly}
    propStyles={propStyles}
  />;
}
